<template>
    <div v-if="block.displayCombos"
         class="home-block home-combos"
         :class="{'is-mobile' : !isDesktop, 'is-safari-desktop' : isSafariDesktop, 'slider-is-moving' : sliderIsScrolling }"
         @mousemove="triggerDetection"
         v-observe-visibility="{
            callback: visibilityChanged,
            once: true,
            intersection:{
                rootMargin: `${block.observeMargin}px 0px ${block.observeMargin}px 0px`
            }
        }" :id="block.elementId">
        <h2 v-html="!isLoading ? block.title : '&nbsp;'"></h2>
        <div class="home-block-content" :style="{height: `${blockHeight}px`}">
            <div v-show="isDesktop && backShow" class="block-back" @click="back()">
                <span class="ecom-chevron-left"></span>
            </div>
            <div v-if="inViewPort" class="home-products-scroll combo-products" @scroll="scrollEvent" ref="block" dir="ltr" id="comboBlock">
                <div class="block-content" :style="{height: `${blockHeight}px`}" @scroll="scrollEvent">
                    <div v-if="!isLoading && isDesktop" class="block-snaps" ref="snaps">
                        <div v-for="n in block.snaps" class="block-snap" :class="{'block-snap-last': n == block.snaps}" :key="n" :style="{width: n == block.snaps ? `${widthLastSnap}px` : `${(blockWidth * roundNumberProducts)}px`, scrollSnapAlign: n == block.snaps ? 'end' : snapAlign }">&nbsp;</div>
                    </div>
                    <div class="blocks" :style="isIE ? {width: `${viewWidth * block.snaps}px`} : {}">
                        <div v-if="isDesktop" class="slider-margin" :style="{width: `calc(var(--vw, 1vw) * ${margin})`}"/>
                        <template v-if="isLoading">
                            <div class="slider-itens">
                                <div v-for="n in roundNumberProducts" class="slider-item" :key="n" :style="{width: `${blockWidth}px`,height: `${blockHeight}px`}">
                                    <div class="slider-item-content skeleton-box"/>
                                </div>
                            </div>
                        </template>
                        <div v-for="n in block.snaps" class="slider-itens" :key="n">
                            <div v-for="(product,index) in block.matrix[n]" :key="'combo-item-'+index" class="slider-item" :style="{width: `${blockWidth}px`}">
                                <div class="slider-item-content" :data-comboid="product.comboId" :data-couponid="product.couponId" :style="`border-width: ${borderWidth}px;`" ref="product">
                                    <ComboHomeBlock
                                        :combo-data="product"
                                        :index="index"
                                        :key="'combo-' + product.comboId"
                                        :is-desktop="isDesktop"
                                        :block-loaded="!isLoading"
                                        @open-combo-modal="comboClick"
                                    />
                                </div>
                            </div>
                            <div v-if="block.hasDiscovery && block.length <= (n * roundNumberProducts)" class="slider-item" :style="{width: `${viewMoreBlockWidth}px`}" @click="gotoUrl(block.discovery.url)">
                                <div class="slider-item-content slider-box-view-more">
                                    <div class="w-100 text-center">{{ block.discovery.title }}</div>
                                    <div>
                                        <a class="discovery" :href="block.discovery.url">{{ block.discovery.label }}</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="isDesktop" class="slider-margin" :style="{width: `calc(var(--vw, 1vw) * ${margin})`}"/>
                    </div>
                </div>
            </div>
            <div v-show="isDesktop && nextShow" class="block-next" @click="forward()">
                <span class=" ecom-chevron-right"></span>
            </div>
        </div>
        <div v-if="isDesktop && showDetails" class="slider-item-content slider-item-content-details"
             :class="{'slider-item-content-details-scale': detailsScale, 'slider-item-content-details-left': classLeft, 'slider-item-content-details-right': classRight,'slider-item-content-details-scale-vertical': detailsScale && heightRate>1.5,'slider-item-content-details-scale-four': detailsScale && block.numberItens==2}"
             @mouseleave.self="detailsDisabled"
             @click.prevent="detailsClick"
             :style="detailsStyle"
             v-html="detailsContent">
        </div>
        <ComboCart v-if="comboModal"
                   :is-desktop="isDesktop"
                   :couponId="couponId"
                   :comboId="comboId"
                   @close="setModal(false)"
                   webEventValue="HOME"
        />
        <CartNotification
            v-if="!isDesktop && cartNotification"
            :class="{'shrink': cartNotification && cartNotification.animationState === 'shrink','shrink jump': cartNotification && cartNotification.animationState === 'jump'}"
            :notification-data="cartNotification"
            @fademe="resetNotification"
        />
    </div>
</template>
<script>

import {storeCombos} from '@/store/comboCart';

import ComboHomeBlock from '@/components/ComboCart/ComboHomeBlock';
import ComboCart from '@/components/ComboCart/ComboCart';
import CartNotification from '@/components/AddToCart/partials/notifications/CartNotification';

import HomeBlock from '@/models/home-block';
import browser from '@/Utilities/browser';
import homeUtils from '@/Utilities/homeUtils';
import utilities from '@/Utilities/common';
import operatingSystem from '@/Utilities/operating-system';
import timer from '@/Utilities/timer';
import websiteEvents from '@/Utilities/website-events';

export default {
    storeCombos,
    name: 'SlideCombos',
    components: {
        ComboHomeBlock,
        ComboCart,
        CartNotification
    },
    props: {
        block: {
            type: HomeBlock,
        },
        heightRate: {
            type: Number,
            default: 1,
        },
        widthRate: {
            type: Number,
            default: 2,
        },
        snapAlign: {
            type: String,
            default: 'center',
        },
        numeration: {
            type: Boolean,
            default: false,
        },
        margin: {
            type: Number,
            default: 3,
        },
        borderWidth: {
            type: Number,
            default: 2,
        },
        isDesktop: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            selectedEle: null,
            blockHeight: 0,
            blockWidth: 0,
            viewMoreBlockWidth: 0,
            backShow: false,
            nextShow: false,
            showDetails: false,
            classLeft: false,
            classRight: false,
            detailsStyle: {},
            detailsTimer: null,
            scrollTimer: null,
            detectItemTimer: null,
            counterTimer: null,
            detailsScale: false,
            detailsContent: '',
            viewWidth: 0,
            inViewPort: false,
            isScrolled: false,
            comboId: null,
            //modalComboId: null,
            //clickOutOfViewport: false
            sliderIsScrolling: false
        };
    },
    mounted() {
        this.calcSize();
        this.block.load();
        storeCombos.dispatch('isDesktop', this.isDesktop);
        //console.log('COMBOBLOCK: ', this.block);
    },
    updated() {
        const elem = this.$refs.block;
        if (elem && elem.scrollLeft == 0) {
            this.nextShow = this.block.CombosLength > this.block.numberItens;
        }
    },
    created() {
        window.addEventListener('resize', this.calcSize);
        window.addEventListener('scroll', this.windowScroll);
    },
    destroyed() {
        window.removeEventListener('resize', this.calcSize);
        window.removeEventListener('scroll', this.windowScroll);
    },
    watch: {
        comboModal(value) {
            if (value) {
                utilities.disableBodyScroll(false, true, true, this.isFirefoxDesktop);
                //console.log('disable!');
            } else {
                utilities.enableBodyScroll();
                //console.log('enable!');
            }
        },
        showDetails(newValue){
            let rect = this.selectedEle.getBoundingClientRect();
            let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            let scrollLeft = document.documentElement.scrollLeft || document.body.scrollLeft;
            this.detailsStyle = {
                top: `${rect.top + scrollTop - this.borderWidth}px`,
                left: `${rect.left + scrollLeft - this.borderWidth}px`,
                width: `${this.blockWidth + (this.borderWidth * 2)}px`,
                height: `${this.blockHeight + (this.borderWidth * 2)}px`
            };
            setTimeout(() => {
                this.detailsScale = newValue
                if(newValue){
                    this.detailsTimerCounter();
                }
            }, 30);
        },
        isLoading(newValue, oldValue) {
            if (!newValue && oldValue) {
                const elem = this.$refs.block;
                if (elem) {
                    elem.scrollTo(0, 0);
                }

                if(this.block.displayCombos){
                    // let metadata = null;
                    // if(typeof this.block.matrix[0].couponId !== 'undefined'){
                    //     // currently, all combos share the same coupon
                    //     metadata = {coupon: this.block.matrix[0].couponId }
                    // }

                    //coupon: this.comboData.couponId
                    websiteEvents.eventCombo('show-block', 'HOME', null);
                }
            }
        },
    },
    computed: {
        widthLastSnap(){
            let numberBlocksRemaining = this.block.CombosLength - (Math.floor(this.block.CombosLength / this.roundNumberProducts) * this.roundNumberProducts);
            if(numberBlocksRemaining <= 0){
                numberBlocksRemaining = this.roundNumberProducts;
            }
            let result = (numberBlocksRemaining * this.blockWidth) + ((this.viewWidth * (this.margin / 100)) * 2);
            if(this.block.hasDiscovery && this.widthRate > 1){
                result = result - (this.blockWidth * ( 1 - ( 1 / this.widthRate )));
            }
            return result;
        },
        isIE() {
            return browser.isIE();
        },
        isSafariDesktop() {
            return operatingSystem.isMacOS() && browser.isSafari();
        },
        isFirefoxDesktop() {
            return this.isDesktop && browser.isFirefox();
        },
        isLoading() {
            return this.block && this.block.isLoading;
        },
        roundNumberProducts() {
            return Math.floor(this.block.numberItens);
        },
        numberItens() {
            return this.block.numberItens;
        },
        /*comboId() {
            return this.selectedEle ? this.selectedEle.dataset.comboid : null;
        },*/
        couponId() {
            return storeCombos.getters.couponId[this.comboId];
        },
        comboModal() {
            /*if(storeCombos.getters.showComboModal[this.comboId]) {
                utilities.disableBodyScroll()
            } else  {
                utilities.enableBodyScroll()
            }*/
            //console.log('modal status: ', storeCombos.getters.showComboModal);
            return storeCombos.getters.showComboModal[this.comboId] ? storeCombos.getters.showComboModal[this.comboId] : null;
        },
        cartNotification() {
            return storeCombos.getters.cartNotification;
        },
    },
    methods: {
        visibilityChanged(isVisible) {
            this.inViewPort = isVisible;
            if (isVisible) {
                this.block.load();
            }
        },
        gotoUrl(url) {
            homeUtils.gotoUrl(url, this.block);
        },
        detailsTimerCounter(){
            let details = this.$refs.details;
            if(details && this.showDetails){
                let timerLabel = details.querySelector('.label-timer');
                if(timerLabel){
                    let time   = timerLabel.dataset.timer ? parseInt(timerLabel.dataset.timer) : 0;
                    this.timerCounter(timerLabel,time);
                }
            }
        },
        timerCounter(label,time){
            let structTime = timer.calcTimerCounter(time);
            if(structTime){
                label.innerHTML = timer.formatNumberCounter(structTime.hours) + ':' + timer.formatNumberCounter(structTime.mins) + ':' + timer.formatNumberCounter(structTime.secs);
                this.counterTimer  = setTimeout(() => { this.timerCounter(label,time) }, 1000);
            }
        },
        scrollEvent() {
            this.detailsDisabled();
            const elem = this.$refs.block;
            const eSnaps = this.$refs.snaps;
            if (elem && eSnaps) {
                this.isScrolled = true;
                const wWidth = homeUtils.getViewPortWidth(!this.isDesktop);
                //let maxedScrollRight = elem.scrollLeft == (elem.scrollWidth - elem.clientWidth);
                //this.nextShow = (eSnaps.offsetWidth > elem.scrollLeft + wWidth + (this.blockWidth * 2) || !maxedScrollRight);
                this.nextShow = eSnaps.offsetWidth > elem.scrollLeft + wWidth + (this.margin / 100 * wWidth);
                this.backShow = elem.scrollLeft > wWidth * this.margin / 100;
                if (this.inViewPort) {
                    this.scrollTimer = setTimeout(() => { this.endBlockScroll(); }, 300);
                }
            }
            this.sliderIsScrolling = true;
        },
        endBlockScroll() {
            this.triggerDetection();
            this.sliderIsScrolling = false;
        },
        windowScroll() {
            this.detailsDisabled();
            if (this.inViewPort) {
                this.scrollTimer = setTimeout(() => { this.triggerDetection(); }, 100);
            }
        },
        triggerDetection() {
            if(this.detailsScale || !this.inViewPort || !this.block.isHoverandZoomActivated){
                return;
            }
            this.detailsDisabled();
            if (this.inViewPort) {
                this.detectItemTimer = setTimeout(() => { this.detectItemOver(); }, 100);
            }

            const elem = this.$refs.block;
            if (elem && elem.scrollLeft == 0) {
                this.nextShow = this.block.CombosLength > this.block.numberItens;
            }
        },
        detectItemOver() {
              if (this.detailsScale || !this.inViewPort) {
                  return;
              }

            //is not the best solution, but is the only possible
            if (this.isDesktop && this.$refs.product) {
                this.$refs.product.forEach(ele => {
                    let l = ele.querySelector('.combo-can-zoom');
                    if (l) {
                        let c = window.getComputedStyle(l, '::before').getPropertyValue('content');
                        if (c == '" "') {
                            this.itemZoom(ele);
                            return;
                        }
                    }
                });
            }
        },
        back() {
            const elem     = this.$refs.block;
            const sliderMargin = Math.round(this.viewWidth * (this.margin * 2 / 100));
            //const widthCrt = (this.blockWidth * this.roundNumberProducts) + this.widthLastSnap;
            //const lastScr  = widthCrt > this.viewWidth ? (widthCrt - this.viewWidth + sliderMargin) : widthCrt;
            //const left     = this.nextShow ? this.blockWidth * this.roundNumberProducts : lastScr;
            const left     = this.nextShow ? this.blockWidth * this.roundNumberProducts : Math.max((this.widthLastSnap / 3),(this.blockWidth / 2));
            const value    = left > 0 ? -left : 0;

            this.scrollTimer = setTimeout(() => { this.smoothScrolling(elem,value); }, 100);
        },
        forward(){
            const elem  = this.$refs.block;
            const value = this.blockWidth * this.roundNumberProducts;
            this.scrollTimer = setTimeout(() => { this.smoothScrolling(elem,value); }, 100);
        },
        smoothScrolling(e,value){
            e.scrollBy({
                top: 0,
                left: value,
                behavior: 'smooth'
            });
        },

        comboClick(comboId = null) { // for mobile 
            //console.log('abre crl!', comboId);
            if (comboId) {
                this.setModal(true, comboId);
            }
        },

        detailsClick() {
            //console.log('selected comboId: ', this.comboId);
            if (this.comboId || this.selectedEle.hasAttribute('data-comboid')) {
                this.setModal(true);
                //storeCombos.dispatch('setComboModal', {[this.selectedEle.dataset.comboid]: true});
            }
        },
        itemZoom(element) {
          /*  while (!element.getAttribute('class').includes('slider-item-content')) {
                element = element.parentElement;
            }*/
            
            this.selectedEle = element;
            this.comboId = this.selectedEle.dataset.comboid;
            /*this.clickOutOfViewport = true;
            if (homeUtils.isBlockInViewport(element)) {*/
                //this.clickOutOfViewport = false;
                //console.log('selected elm: ', this.selectedEle);
                let rect = this.selectedEle.getBoundingClientRect();
                let detailsLeft = rect.left < this.blockWidth;
                let detailsRight = rect.left > (this.blockWidth + this.borderWidth) * (this.block.numberItens - 1);
                let wrap = document.createElement('div');
                wrap.appendChild(element.cloneNode(true));
                this.detailsScale = false;
                this.detailsTimer = setTimeout(() => {
                    this.detailsContent = wrap.innerHTML;
                    this.classLeft = detailsLeft;
                    this.classRight = detailsRight;
                    this.showDetails = true;
                }, 50);
            //}
            //console.log('clickOutOfViewport', this.clickOutOfViewport);
        },
        detailsDisabled() {
            clearTimeout(this.detailsTimer);
            clearTimeout(this.scrollTimer);
            clearTimeout(this.detectItemTimer);
            clearTimeout(this.counterTimer);
            this.detailsScale = false;
            setTimeout(() => {this.showDetails = false}, 150);
        },
        calcSize() {
            this.viewWidth = homeUtils.getViewPortWidth(!this.isDesktop);
            let marWidth = Math.round(this.viewWidth * (this.margin * 2 / 100));
            let proWidth = (this.viewWidth - marWidth) / this.block.numberItens;
            this.blockWidth = Math.round(proWidth);
            this.blockHeight = (this.blockWidth / this.widthRate) * this.heightRate;
            this.viewMoreBlockWidth = this.blockWidth / this.widthRate;
        },
        setModal(status, comboId = null) {
            if (comboId) {
                // used in mobile only or desktop < 70% visible
                this.comboId = comboId;
                //storeCombos.dispatch('setComboModal', {[comboId]: status});
            } 
            
            storeCombos.dispatch('setComboModal', {[this.comboId]: status});
            

            if(!this.isDesktop) {
                utilities.eventModalApp(status);
            }
        },
        resetNotification() {
            storeCombos.dispatch('setCartNotification', null);
        },
    },
};
</script>